import { Component, input, output } from "@angular/core";
import { Icon } from "../../icon/icon.component";

@Component({
    selector: "app-action-sheet-header",
    template: `
        <div class="flex justify-between w-full p-4">
            <div class="flex gap-2 items-center">
                @if (icon(); as icon) {
                    <app-icon [name]="icon" class="text-primary" />
                }
                <p class="text-gray-800 lg:text-lg">
                    <ng-content />
                </p>
            </div>
            @if (multiple(); as multiple) {
                <p (click)="reset.emit()" class="text-gray-400 text-sm">
                    초기화
                </p>
            } @else {
                <p (click)="close.emit()" class="text-gray-400 text-sm">취소</p>
            }
        </div>
    `,
    imports: [Icon],
})
export class ActionSheetHeader {
    icon = input<string>();
    close = output<void>();
    multiple = input<boolean>();
    reset = output<void>();
}
